<template>

      <!-- @todo - The menu needs to be an include file so its repeated on all pages -->
      <div class="bg-gray-50">

        <!-- menu component -->
        <menu-public></menu-public>
        
        <div class="relative overflow-hidden">
                    
           <div class="p-10 mx-auto max-w-7xl px-4  sm:px-6">

                <div class="relative lg:grid lg:grid-cols-12 lg:gap-x-5">
                    
                    <aside class="py-6 px-2 sm:px-6 lg:py-0 lg:px-0 lg:col-span-2">
                        <nav class="space-y-1">
                        <!-- Current: "bg-gray-50 text-indigo-700 hover:text-indigo-700 hover:bg-white", Default: "text-gray-900 hover:text-gray-900 hover:bg-gray-50" -->
                        <a @click="showProfile()" class="bg-gray-50 text-indigo-700 hover:text-indigo-700 hover:bg-white group rounded-md px-3 py-2 flex items-center text-sm font-medium" aria-current="page">
                            <!-- Current: "text-indigo-500 group-hover:text-indigo-500", Default: "text-gray-400 group-hover:text-gray-500" -->
                            <!-- Heroicon name: user-circle -->
                            <svg class="text-indigo-500 group-hover:text-indigo-500 flex-shrink-0 -ml-1 mr-3 h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            <span class="truncate">
                            Account
                            </span>
                        </a>

                        <a @click="showPassword()" class="text-gray-900 hover:text-gray-900 hover:bg-gray-50 group rounded-md px-3 py-2 flex items-center text-sm font-medium">
                            <!-- Heroicon name: key -->
                            <svg class="text-gray-400 group-hover:text-gray-500 flex-shrink-0 -ml-1 mr-3 h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
                            </svg>
                            <span class="truncate">
                            Password
                            </span>
                        </a>

                        <a @click="showBill()" class="text-gray-900 hover:text-gray-900 hover:bg-gray-50 group rounded-md px-3 py-2 flex items-center text-sm font-medium">
                            <!-- Heroicon name: credit-card -->
                            <svg class="text-gray-400 group-hover:text-gray-500 flex-shrink-0 -ml-1 mr-3 h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                            </svg>
                            <span class="truncate">
                            Plan &amp; Billing
                            </span>
                        </a>

                        <a href="#" class="text-gray-900 hover:text-gray-900 hover:bg-gray-50 group rounded-md px-3 py-2 flex items-center text-sm font-medium">
                            <!-- Heroicon name: user-group -->
                            <svg class="text-gray-400 group-hover:text-gray-500 flex-shrink-0 -ml-1 mr-3 h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                            </svg>
                            <span class="truncate">
                            Team
                            </span>
                        </a>

                        <a href="#" class="text-gray-900 hover:text-gray-900 hover:bg-gray-50 group rounded-md px-3 py-2 flex items-center text-sm font-medium">
                            <!-- Heroicon name: view-grid-add -->
                            <svg class="text-gray-400 group-hover:text-gray-500 flex-shrink-0 -ml-1 mr-3 h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 14v6m-3-3h6M6 10h2a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v2a2 2 0 002 2zm10 0h2a2 2 0 002-2V6a2 2 0 00-2-2h-2a2 2 0 00-2 2v2a2 2 0 002 2zM6 20h2a2 2 0 002-2v-2a2 2 0 00-2-2H6a2 2 0 00-2 2v2a2 2 0 002 2z" />
                            </svg>
                            <span class="truncate">
                            Support
                            </span>
                        </a>
                        </nav>
                    </aside>

                    <div class="space-y-6 sm:px-6 lg:px-0 lg:col-span-10">

                            <template class="transition duration-700 ease-in-out" v-if="accountProfile">

                                  <form action="#" method="POST">
                                        <div class="shadow sm:rounded-md sm:overflow-hidden">
                                            <div class="bg-white py-6 px-4 space-y-6 sm:p-6">
                                            <div>
                                                <h3 class="text-lg leading-6 font-medium text-gray-900">Profile</h3>
                                                <p class="mt-1 text-sm text-gray-500">This information will be displayed publicly so be careful what you share.</p>
                                            </div>



                                                    <div class="space-y-6 sm:space-y-5">
                                                        <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                                                        <label for="first_name" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                                                            Name
                                                        </label>
                                                        <div class="mt-1 sm:mt-0 sm:col-span-2">
                                                            <input type="text"  v-model="user.name" class="p-2 max-w-lg block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm border-gray-300 rounded-md">
                                                        </div>
                                                        </div>

                                                        <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                                                        <label for="email" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                                                            Email address
                                                        </label>
                                                        <div class="mt-1 sm:mt-0 sm:col-span-2">
                                                            <input id="email" v-model="user.email" class="p-2 max-w-lg block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm border-gray-300 rounded-md">
                                                        </div>
                                                        </div>

                                                        <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                                                        <label for="street_address" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                                                            Address
                                                        </label>
                                                        <div class="mt-1 sm:mt-0 sm:col-span-2">
                                                            <input type="text" v-model="user.address" class="p-2 max-w-lg block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm border-gray-300 rounded-md">
                                                        </div>
                                                        </div>

                                                        <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                                                        <label for="city" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                                                            City
                                                        </label>
                                                        <div class="mt-1 sm:mt-0 sm:col-span-2">
                                                            <input v-model="user.city" class="p-2 max-w-lg block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm border-gray-300 rounded-md">
                                                        </div>
                                                        </div>

                                                        <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                                                        <label for="state" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                                                            State / Province
                                                        </label>
                                                        <div class="mt-1 sm:mt-0 sm:col-span-2">
                                                            <input type="text" v-model="user.state" class="p-2 max-w-lg block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm border-gray-300 rounded-md">
                                                        </div>
                                                        </div>

                                                        <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                                                        <label for="zip" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                                                            ZIP / Postal
                                                        </label>
                                                        <div class="mt-1 sm:mt-0 sm:col-span-2">
                                                            <input type="text" v-model="user.zip" class="p-2 max-w-lg block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm border-gray-300 rounded-md">
                                                        </div>
                                                        </div>
                                                    </div>
                                             

                                            </div>
                                            <div class="px-4 py-3 bg-gray-50 text-right sm:px-6">
                                            <!-- <button type="submit" class="bg-indigo-600 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                                Save
                                            </button> -->
                                            </div>
                                        </div>
                                    </form>
                            
                            </template>


                            
                            <template class="transition duration-700 ease-in-out" v-if="displayPass">

                                  <v-form ref="form" v-model="valid">
                                        <div class="shadow sm:rounded-md sm:overflow-hidden">
                                            <div class="bg-white py-6 px-4 space-y-6 sm:p-6">
                                            <div>
                                                <h3 class="text-lg leading-6 font-medium text-gray-900">Password</h3>
                                                <p class="mt-1 text-sm text-gray-500">Change your password.</p>
                                            </div>

                                                    <div class="space-y-6 sm:space-y-5">
                                                        <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">

                                                            <label for="password" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                                                                New Password
                                                            </label>
                                                            <div class="mt-1 sm:mt-0 sm:col-span-2">
                                                                  <v-text-field
                                                                   class="p-2 max-w-lg block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
                                                                        v-model="password"
                                                                        :counter="15"
                                                                        :rules="[v => !!v || 'password is required', v => (v && v.length >= 8) || 'password greater than 8 characters']"
                                                                        type="password"
                                                                        required
                                                                ></v-text-field>
                                                            </div>

                                                        </div>

                                                        <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                                                            <label for="password_confirmation" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                                                                Confirm Password
                                                            </label>
                                                            <div class="mt-1 sm:mt-0 sm:col-span-2">
                                                                 <v-text-field
                                                                  class="p-2 max-w-lg block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
                                                                    type="password"
                                                                    :counter="15"
                                                                    v-model="password_confirmation"
                                                                    :rules="[
                                                                    password === password_confirmation ||
                                                                        'Password must match'
                                                                    ]"
                                                                    required
                                                                ></v-text-field>
                                                            </div>
                                                        </div>


                                                    </div>

                                            </div>
                                            <div class="px-4 py-3 bg-gray-50 text-right sm:px-6">
                                                <button @click.prevent="changePass()" :disabled="!valid" type="submit" class="disabled:opacity-50 bg-indigo-600 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                                    Save
                                                </button> 
                                            </div>
                                            
                                        </div>
                                        
                                    </v-form>
                            
                            </template>


                            <template class="transition duration-700 ease-in-out" v-if="formProfile">

                                <div class="py-12 bg-white">
                                <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                                    <div class="lg:text-center">
                                    <h2 class="text-base text-indigo-600 font-semibold tracking-wide uppercase">Transactions</h2>
                                    <p class="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                                        Bill Pay
                                    </p>
                                    <!-- <p class="max-w-2xl text-medium text-gray-500 lg:mx-auto">
                                        Check the status | download pdf | validate
                                    </p> -->
                                    </div>

                                    <pay-sub v-if="user.subscriptions == ''">  </pay-sub>

                                        <div class="flex flex-col mt-4">
                                        <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                            <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                                            <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">

                                                <table class="min-w-full divide-y divide-gray-200">
                                                    <thead class="bg-gray-50">
                                                        <tr>
                                                        <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                        Invoice # 
                                                        </th>
                                                        <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                            Hosted Invoice Url
                                                        </th>

                                                        <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                            Invoice Pdf
                                                        </th>

                                                        <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                        Status
                                                        </th>
                                                        <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                            Actions
                                                        </th>

                                                        </tr>
                                                    </thead>
                                                    <tbody v-if="user.sub_invoices" class="bg-white divide-y divide-gray-200">
                                                        <tr v-for="invoice in user.sub_invoices" :key="invoice.id">
                                                        <td class="px-6 py-4 whitespace-nowrap">
                                                            {{ invoice.invoice_id}}
                                                        </td>
                                                        <td class="px-6 py-4 whitespace-nowrap">
                                                            <a :href="invoice.hosted_invoice_url" target="_blank" class="font-bold bg-indigo-500 mt-2 rounded-full px-4 py-2  text-white text-xs hover:text-indigo-900">Pay Bill</a>
                                                        </td>
                                                        <td class="px-6 py-4 whitespace-nowrap">
                                                            <a :href="invoice.invoice_pdf" class="font-bold bg-gray-500 mt-2 rounded-full px-4 py-2  text-white text-xs hover:text-gray-900">Download Invoice</a>
                                                        </td>
                                                        <td class="px-6 py-4 whitespace-nowrap">
                                                            <template v-if="invoice.paid_at === 'open'">
                                                                <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800">
                                                                {{ invoice.paid_at }}
                                                                </span>
                                                            </template>
                                                            <template v-else>
                                                                <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                                                                {{ invoice.paid_at }}
                                                                </span>
                                                            </template>
                                                    
                                                        </td>

                                                        <td class="px-6 py-4 whitespace-nowrap text-sm font-medium">
                                                            <a v-if="invoice.paid_at === 'open'" @click="updateInvoice(invoice)" class="text-indigo-600 hover:text-indigo-900">Already Paid?</a>
                                                            <a v-else @click="invoiceDetails(invoice)" class="text-indigo-600 hover:text-indigo-900">Details</a>
                                                        </td>
                                                        </tr>

                                                        <!-- More items... -->
                                                    </tbody>
                                                </table>
                                            </div>
                                            </div>
                                        </div>
                                        </div>

                                </div>
                                </div>

                            </template>
           
                    </div>

                </div>


            </div>


        </div>

        <v-dialog
            v-if="dialog"
            v-model="dialog"
            width="500"
            >

            <v-card>
                <v-card-title class="headline grey lighten-2">
                Invoice Details
                </v-card-title>

                <v-card-text>
                    <div class="mt-6">
                        <p> Finalized At:
                        <span class="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-green-100 text-green-800">
                        {{ formatDate(invoiceData.finalized_at) }}
                        </span> </p> 
                        <p> Paid At: 
                        <span class="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
                        {{ formatDate(invoiceData.paid_at) }} 
                        </span>
                        </p>
                    </div>
                   


                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        text
                        @click="dialog = false"
                    >
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
            </v-dialog>


      </div>

</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
        dialog: false,
        invoiceData: "",
        formProfile: true,
        accountProfile: false,
        displayPass: false,
        //   <img class="h-10 w-10 rounded-full" :src="url + user.name + endUrl" alt="">

        url: "https://ui-avatars.com/api/?name=",
        endUrl: "&background=ccf3ff&color=0099cc",

        errors: [],
        password: "",
        password_confirmation: "",
        valid: true,

    };
  },

    computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters([
      'user',
    ])
  },

  methods: {

        formatDate(newDate) {
            var a = new Date(newDate * 1000);
            var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
            var year = a.getFullYear();
            var month = months[a.getMonth()];
            var date = a.getDate();
            var hour = a.getHours();
            var min = a.getMinutes();
            var sec = a.getSeconds();
            var time = date + ' ' + month + ' ' + year + ' ' + hour + ':' + min + ':' + sec ;
            return time;

        },

      showProfile() {
          this.accountProfile = true
          this.formProfile = false
          this.displayPass = false
      },
      showBill() {
          this.formProfile = true
          this.accountProfile = false
          this.displayPass = false
      },

     showPassword() {
          this.displayPass = true
          this.accountProfile = false
          this.formProfile = false
      },

      updateInvoice(invoice) {
        window.axios.get("/api/updateInvoice/" + invoice.invoice_id).then(() => {
            this.user
        });
      },

      invoiceDetails(invoice) {
        window.axios.get("/api/invoiceDetails/" + invoice.invoice_id).then((res) => {
            this.invoiceData = res.data
            this.dialog = true
        });
      },

    dollar(value) {
      return value / 100;
    },

      changePass(){
           window.axios.post("/api/changePass", {
               id: + this.user.id,
               password: this.password
           }).then(() => {
                this.user
                this.password = "",
                this.password_confirmation = ""
                this.$swal('Success!', 'Password successfully changed')
        });
      }
  }
};
</script>
